import { render, staticRenderFns } from "./SettingsMandate.vue?vue&type=template&id=ef06c3c0&scoped=true&"
import script from "./SettingsMandate.vue?vue&type=script&lang=js&"
export * from "./SettingsMandate.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMandate.vue?vue&type=style&index=0&id=ef06c3c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef06c3c0",
  null
  
)

export default component.exports